import React from "react";
import ReactDOM from "react-dom";

const favRoot = document.getElementById('favRoot');
const unfavRoot = document.getElementById('unfavRoot');
const favSmallScreenRoot = document.getElementById('favSmallScreenRoot');
const unfavSmallScreenRoot = document.getElementById('unfavSmallScreenRoot');
const addToCartBtnRoot = document.getElementById('addToCartBtnRoot');
const addToCartSmallScreenBtnRoot = document.getElementById('addToCartSmallScreenBtnRoot');

class FavoritedIconPortal extends React.Component {
  constructor(props) {
    super(props);
    this.favEl = document.createElement('div');
  }

  componentDidMount() {
    if (favRoot != null)
    {
      favRoot.appendChild(this.favEl);
    }
    
  }
  
  render() {
    // Use a portal to render the children into the element
    return ReactDOM.createPortal(
      // Any valid React child: JSX, strings, arrays, etc.
      this.props.children,
      this.favEl,
    );
  }
}

class UnFavoritedIconPortal extends React.Component {
  constructor(props) {
    super(props);
    this.unfavEl = document.createElement('div');
  }

  componentDidMount() {
    if (unfavRoot != null)
    {
      unfavRoot.appendChild(this.unfavEl);
    }
  }
  
  render() {
    // Use a portal to render the children into the element
    return ReactDOM.createPortal(
      // Any valid React child: JSX, strings, arrays, etc.
      this.props.children,
      this.unfavEl,
    );
  }
}

class FavoritedIconSmallScreenPortal extends React.Component {
  constructor(props) {
    super(props);
    this.favSmallScreenEl = document.createElement('div');
  }

  componentDidMount() {
    if (favSmallScreenRoot != null)
    {
      favSmallScreenRoot.appendChild(this.favSmallScreenEl);
    }
  }
  
  render() {
    // Use a portal to render the children into the element
    return ReactDOM.createPortal(
      // Any valid React child: JSX, strings, arrays, etc.
      this.props.children,
      this.favSmallScreenEl,
    );
  }
}

class UnFavoritedIconSmallScreenPortal extends React.Component {
  constructor(props) {
    super(props);
    this.unfavSmallScreenEl = document.createElement('div');
  }

  componentDidMount() {
    if (unfavSmallScreenRoot != null)
    {
      unfavSmallScreenRoot.appendChild(this.unfavSmallScreenEl);
    }
  }
  
  render() {
    // Use a portal to render the children into the element
    return ReactDOM.createPortal(
      // Any valid React child: JSX, strings, arrays, etc.
      this.props.children,
      this.unfavSmallScreenEl,
    );
  }
}

class AddToCartBtnPortal extends React.Component {
  constructor(props) {
    super(props);
    this.addToCartBtnEl = document.createElement('div');
  }

  componentDidMount() {
    if (addToCartBtnRoot != null)
    {
      addToCartBtnRoot.appendChild(this.addToCartBtnEl);
    }
  }
  
  render() {
    // Use a portal to render the children into the element
    return ReactDOM.createPortal(
      // Any valid React child: JSX, strings, arrays, etc.
      this.props.children,
      this.addToCartBtnEl,
    );
  }
}

class AddToCartSmallScreenBtnPortal extends React.Component {
  constructor(props) {
    super(props);
    this.addToCartSmallScreenBtnEl = document.createElement('div');
  }

  componentDidMount() {
    if (addToCartSmallScreenBtnRoot != null)
    {
      addToCartSmallScreenBtnRoot.appendChild(this.addToCartSmallScreenBtnEl);
    }
  }
  
  render() {
    // Use a portal to render the children into the element
    return ReactDOM.createPortal(
      // Any valid React child: JSX, strings, arrays, etc.
      this.props.children,
      this.addToCartSmallScreenBtnEl,
    );
  }
}

class ProductWidgets extends React.Component {
  constructor(props) {
    super(props);
    this.state = { productId: '', isAddedToCart: false,
    favoritedIconClassName: 'favorite-icon-favorited',
    unfavoritedIconClassName: 'favorite-icon-unfavorited' }
  }

  componentDidMount() {
    // disable btn so user can't submit until page is loaded
    var favBtn = document.getElementById('favBtn');
    if (favBtn != null) {
      favBtn.disabled = true;
    }
    var unfavBtn = document.getElementById('unfavBtn');
    if (unfavBtn != null) {
      unfavBtn.disabled = true;
    }
    var favSmallScreenBtn = document.getElementById('favSmallScreenBtn');
    if (favSmallScreenBtn != null) {
      favSmallScreenBtn.disabled = true;
    }
    var unfavSmallScreenBtn = document.getElementById('unfavSmallScreenBtn');
    if (unfavSmallScreenBtn != null) {
      unfavSmallScreenBtn.disabled = true;
    }
    
    fetch('get-session-cookie-product-id', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
    })
    .then((res) => res.json())
    .then(data => {
      if (data.errorMessage == "error") {
        window.location.href = window.location.origin + "/error"
      } 
      else {
        this.setState({ productId: data.productId });
        
        // disable btn so user can't submit until page is loaded
        var favBtn = document.getElementById('favBtn');
        if (favBtn != null) {
          favBtn.disabled = false;
        }
        var unfavBtn = document.getElementById('unfavBtn');
        if (unfavBtn != null) {
          unfavBtn.disabled = false;
        }
        var favSmallScreenBtn = document.getElementById('favSmallScreenBtn');
        if (favSmallScreenBtn != null) {
          favSmallScreenBtn.disabled = false;
        }
        var unfavSmallScreenBtn = document.getElementById('unfavSmallScreenBtn');
        if (unfavSmallScreenBtn != null) {
          unfavSmallScreenBtn.disabled = false;
        }
      }
      
    });
  } 

  toggleFavorite = (e) => {
    e.preventDefault();

    var btnId = e.currentTarget.id;
    var btn = document.getElementById(btnId)
    if (btn.disabled == false) {
      
      if (btnId == 'favBtn') {
        if (this.state.favoritedIconClassName == 'favorite-icon-favorited') {
          this.setState({ favoritedIconClassName: 'favorite-icon-unfavorited' });
        }
        else {
          this.setState({ favoritedIconClassName: 'favorite-icon-favorited' });
        }
      } 
      
      else if (btnId == 'unfavBtn') {
        if (this.state.unfavoritedIconClassName == 'favorite-icon-unfavorited') {
          this.setState({ unfavoritedIconClassName: 'favorite-icon-favorited' });
        }
        else {
          this.setState({ unfavoritedIconClassName: 'favorite-icon-unfavorited' });
        }
      }

      else if (btnId == 'favSmallScreenBtn') {
        if (this.state.favoritedIconClassName == 'favorite-icon-favorited') {
          this.setState({ favoritedIconClassName: 'favorite-icon-unfavorited' });
        }
        else {
          this.setState({ favoritedIconClassName: 'favorite-icon-favorited' });
        }
      }

      else {
        if (this.state.unfavoritedIconClassName == 'favorite-icon-unfavorited') {
          this.setState({ unfavoritedIconClassName: 'favorite-icon-favorited' });
        }
        else {
          this.setState({ unfavoritedIconClassName: 'favorite-icon-unfavorited' });
        }
      }


      var productId = e.currentTarget.value;
    
      var favoriteModel = new Object();
      favoriteModel.productId = productId;
      
      fetch('toggle-favorite', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(favoriteModel)
      });
    }
  }

  addToCart = async (e) => {
    e.preventDefault();

    this.setState({ isAddedToCart: true });

    var productId = e.currentTarget.value;
  
    var productModel = new Object();
    productModel.productId = productId;
    
    const response = await fetch('add-to-cart', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(productModel)
    });

    const result = await response.json();
    console.log(result)
    if (result.errorMessage === "wrong location") {
      window.location.href = window.location.origin + "/access-denied-location";
    }

    if (result.errorMessage === "no shipping info") {
      window.location.href = window.location.origin + "/user-shipping-info";
    }

    if (result.errorMessage === "no checkout verification") {
      window.location.href = window.location.origin + "/checkout-verify";
    }

    if (result.errorMessage === "no product found") {
      window.location.href = window.location.origin + "/error";
    }
}

  render() {
    const { productId, favoritedIconClassName, unfavoritedIconClassName, isAddedToCart } = this.state
    
    return (
      <div>
        <div>
          
            <FavoritedIconPortal>
              <div style={{position: "relative"}}>
                <button id='favBtn' value={productId}  onClick={ this.toggleFavorite } className="product-page-icon-fav-btn">
                  <svg className="product-page-fav-svg" version="1.1"xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 23">
                      <path className={favoritedIconClassName} d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
                  </svg>
                </button>
                <div className="fav-hover-label" style={{width: "70px"}}>favorite</div>
              </div>
            </FavoritedIconPortal>
            
            <UnFavoritedIconPortal>
              <div style={{position: "relative"}}>
                <button id='unfavBtn' value={productId} onClick={ this.toggleFavorite } className="product-page-icon-fav-btn">
                  <svg className="product-page-fav-svg" version="1.1"xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 23">
                      <path className={unfavoritedIconClassName} d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
                  </svg>
                </button>
                <div className="fav-hover-label" style={{width: "70px"}}>favorite</div>
              </div>
            </UnFavoritedIconPortal>

            <FavoritedIconSmallScreenPortal>
              <div style={{position: "relative", marginTop: "-5px"}}>
                <button id='favSmallScreenBtn' value={productId}  onClick={ this.toggleFavorite } className="product-page-icon-fav-btn">
                  <svg className="product-page-fav-svg" version="1.1"xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 23">
                      <path className={favoritedIconClassName} d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
                  </svg>
                </button>
                <div className="fav-hover-label" style={{width: "70px", marginLeft: "-8px", paddingLeft: "14px"}}>favorite</div>
              </div>
            </FavoritedIconSmallScreenPortal>

            <UnFavoritedIconSmallScreenPortal>
              <div style={{position: "relative", marginTop: "-5px"}}>
                <button id='unfavSmallScreenBtn' value={productId}  onClick={ this.toggleFavorite } className="product-page-icon-fav-btn">
                  <svg className="product-page-fav-svg" version="1.1"xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 23">
                      <path className={unfavoritedIconClassName} d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
                  </svg>
                </button>
                <div className="fav-hover-label" style={{width: "70px", marginLeft: "-8px", paddingLeft: "14px"}}>favorite</div>
              </div>
            </UnFavoritedIconSmallScreenPortal>

            <AddToCartBtnPortal>
              <i style={isAddedToCart ? {color: "rgb(0, 0, 0, 0.2)"} : {}} className="material-icons purchase-onsite-icon">add_shopping_cart</i>
              <button disabled={isAddedToCart ? true : false }  value={productId}  onClick={ this.addToCart } className="add-to-cart-product-page-large-screen" style={isAddedToCart ? {backgroundColor: "rgb(0, 0, 0, 0.2)", width: "105px", cursor: "default"} : {width: "105px"}}><span style={{marginLeft: "4px"}}>Add</span></button>
            </AddToCartBtnPortal>

            <AddToCartSmallScreenBtnPortal>
              <button disabled={isAddedToCart ? true : false } style={isAddedToCart ? {backgroundColor: "rgb(0, 0, 0, 0.2)", cursor: "default"} : {}} value={productId}  onClick={ this.addToCart } className="add-to-cart-product-page-small-screen"><span><i></i></span>Add to Cart</button>
            </AddToCartSmallScreenBtnPortal>
          
        </div>
      </div>
    );
  }
}
export default ProductWidgets;